import React, { useCallback, useEffect, useRef, useState } from "react";
import EquipoModeloService from "../../services/ListaVerificacion/EquipoModeloService";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { useAbortController } from "../../pages/gestionDocumentos/hooks/useAbortController";

interface IFilterCombo {
  search: string;
}


export const useComboModelos = () => {
  const { handleAbortController } = useAbortController();
  const [filter, setFilter] = useState<IFilterCombo>({ search: "" });
  const [dataComboModelos, setDataComboModelos] = useState<IComboBoxOption[]>(
    []
  );

  const comboBoxRefModelos = useRef<IComboBox>(null);
  
  const _openOptionModelos = useCallback(
    () => comboBoxRefModelos.current?.focus(true),
    []
  );

  const onClickComboModelos = () => comboBoxRefModelos.current?.focus(true);

  const _onkeyUpSearchDispositivo = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefModelos.current?.focus(false);
      setFilter({ search: "" });
    } else {
      _openOptionModelos();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ search: value });
    }
  };

  const listarCombo = () => {
    EquipoModeloService.PostListarCombo(filter, handleAbortController()).then((res) => {
      if (res.status === 200) {
        setDataComboModelos(res.data);
      }
    }).catch((e) => {
      console.error(e.message);
    });
  };

  const limpiarFilters = () => {
    setFilter({ search: "" });
  };

  useEffect(() => {
    listarCombo();
  }, [filter]);

  return {
    dataComboModelos,
    listarCombo,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
    limpiarFilters,
  };
};
